import { Component, forwardRef, OnInit, ViewEncapsulation } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { debounceTime, skip, switchMap } from 'rxjs/operators';
import english from '../../../../../main/maintenances/i18n/en.json';
import spanish from '../../../../../main/maintenances/i18n/es.json';
import portuguese from '../../../../../main/maintenances/i18n/pt.json';
import { SegmentService } from '../../../../../main/settings/registers/segments/services/segment.service';
import { Segment } from '../../../../interfaces';

export function ValidateAutocomplete(): object {
  return { required: true };
}

const INPUT_FIELD_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SegmentLegacyComponent),
  multi: true
};

@Component({
  selector: 'segment-legacy',
  templateUrl: './segment.component.html',
  styleUrls: ['./segment.component.scss'],
  providers: [INPUT_FIELD_VALUE_ACCESSOR],
  encapsulation: ViewEncapsulation.None
})
export class SegmentLegacyComponent implements ControlValueAccessor, OnInit {
  public segments = new Array<Segment>();
  public inputValue = new FormControl();
  public selectedSegment: Segment;
  public loading = false;

  constructor(
    private fuseTranslationLoaderService: FuseTranslationLoaderService,
    private segmentService: SegmentService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({english, portuguese, spanish});
  }

  ngOnInit(): void {
    this.inputValue.valueChanges
      .pipe(
        skip(1),
        debounceTime(500),
        switchMap((searchTerm) => {
          this.loading = true;
          this.segments = [];
          return this.segmentService.loadData({
            where: {
              name_contains: searchTerm
            },
            options: {
              orderBy: 'name_asc',
              offset: 0,
              limit: 10
            }
          });
        }),
      )
      .subscribe((result) => {
        this.loading = false;
        this.segments = result.items;
      });
  }

  onChange: (_: any) => void = () => {};
  onTouched: (_: any) => void = () => {};

  writeValue(segmentId: any): void {
    if (segmentId) {
      this.segmentService.getSegmentById(segmentId).then((segment) => {
        this.selectedSegment = segment;
        this.inputValue.setErrors(null);
      });
    } else {
      this.deselectSegment();
    }
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setSelectedSegment(): void {
    if (this.inputValue.value) {
      this.onChange(this.inputValue.value);
      this.selectedSegment = this.segments.find((location) => location.id === this.inputValue.value);
      this.inputValue.setErrors(null);
    }
  }

  deselectSegment(): void {
    this.onChange(null);
    this.inputValue.setValue(null);
    this.selectedSegment = null;
    this.inputValue.setErrors(null);
  }
}
